import { gql } from 'graphql-tag'

const introductionLinkFragment = gql`
  fragment IntroductionLinkFragment on IntroductionLink {
    id
    fileName
    href
    linkTags {
      id
      name
    }
    company {
      id
      name
    }
  }
`

export const fetchIntroductionLinks = gql`
  query FetchIntroductionLinks {
    introductionLinks {
      ...IntroductionLinkFragment
    }
  }
  ${introductionLinkFragment}
`

export const fetchAokIntroductionLinks = gql`
  query FetchAokIntroductionLinks($companyId: ID) {
    aokIntroductionLinks(companyId: $companyId) {
      ...IntroductionLinkFragment
    }
  }
  ${introductionLinkFragment}
`

export const createIntroductionLink = gql`
  mutation CreateIntroductionLink($fileName: String!, $href: String!, $companyId: ID, $linkTagId: ID) {
    createIntroductionLink(fileName: $fileName, href: $href, companyId: $companyId, linkTagId: $linkTagId) {
      ...IntroductionLinkFragment
    }
  }
  ${introductionLinkFragment}
`

export const updateIntroductionLink = gql`
  mutation UpdateIntroductionLink($id: ID!, $fileName: String!, $href: String!, $linkTagId: ID) {
    updateIntroductionLink(id: $id, fileName: $fileName, href: $href, linkTagId: $linkTagId) {
      ...IntroductionLinkFragment
    }
  }
  ${introductionLinkFragment}
`

export const deleteIntroductionLink = gql`
  mutation DeleteIntroductionLink($id: ID!) {
    deleteIntroductionLink(id: $id)
  }
`
